import gql from 'graphql-tag';

import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';
import {Override} from 'util/Types';

import {AnalysisTemplateSelectorQuery_analysisTemplateListing_AnalysisTemplateNode as AnalysisTemplateSelectorQueryAnalysisTemplateListingAnalysisTemplateNode} from './__generated/AnalysisTemplateSelectorQuery';

export const ANALYSIS_TEMPLATE_SELECTOR_QUERY = gql`
  query AnalysisTemplateSelectorQuery @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    analysisTemplateListing(excludeArchived: true) {
      ... on AnalysisTemplateNode {
        id
        name
        archiveRecord {
          purpose
        }
        configVariables {
          id
          name
          configVariableKey
          variableTypeConfigSpec
        }
        dataFrameVariables {
          id
        }
      }
    }
  }
`;

type AnalysisTemplateConfigVariable = Override<
  AnalysisTemplateSelectorQueryAnalysisTemplateListingAnalysisTemplateNode['configVariables'][number],
  {variableTypeConfigSpec: PipelineConfigJsonSpec}
>;

export type AnalysisTemplateSelectorTemplate = Override<
  AnalysisTemplateSelectorQueryAnalysisTemplateListingAnalysisTemplateNode,
  {configVariables: Array<AnalysisTemplateConfigVariable>}
>;
